import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  DeploymentRequestListPageContext,
  DeploymentRequestListPageInitialState,
} from ".";

export const DeploymentRequestListPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    DeploymentRequestListPageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <DeploymentRequestListPageContext.Provider value={context}>
      {children}
    </DeploymentRequestListPageContext.Provider>
  );
};
